export default class Documents {
  constructor (documents) {
    this.id = documents.id
    this.name = documents.name
  }
}
